var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1436,
    height: 823,
    viewBox: "0 0 1436 823",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_9_497)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1445,
    height: 823,
    transform: "translate(-9)",
    fill: "#FFF8EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: 0,
    width: 1445,
    height: 823
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1436 0H-9V823H1436V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_497)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.324 438.395H120.431V482.144H164.324V438.395Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.324 332.777H120.431V376.525H164.324V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.428 376.523L89.3912 407.458L120.428 438.392L151.465 407.458L120.428 376.523Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.291 438.395H226.398V482.144H270.291V438.395Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.291 332.777H226.398V376.525H270.291V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.286 376.526L239.249 407.461L270.286 438.395L301.322 407.46L270.286 376.526Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.358 301.842L164.321 332.776L195.358 363.711L226.394 332.776L195.358 301.842Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.356 451.207L164.32 482.142L195.356 513.077L226.393 482.142L195.356 451.207Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.684 305.619L195.361 263.435L153.038 305.619H93.1843V365.276L50.8611 407.46L93.1843 449.644V509.301H153.038L195.361 551.485L237.684 509.301H297.538V449.644L339.861 407.46L297.538 365.276V305.619H237.684Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.324 31.0312H120.431V74.7799H164.324V31.0312Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.431 -30.8373L89.394 0.0973511L120.431 31.032L151.467 0.0973511L120.431 -30.8373Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.291 31.0312H226.398V74.7799H270.291V31.0312Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.289 -30.8368L239.252 0.0979004L270.289 31.0326L301.325 0.0979004L270.289 -30.8368Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.359 43.8456L164.323 74.7802L195.359 105.715L226.396 74.7802L195.359 43.8456Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.684 101.937L195.361 144.121L153.038 101.937H93.1843V42.2804L50.8611 0.0963019L93.1843 -42.0878V-101.745H153.038L195.361 -143.929L237.684 -101.745H297.538V-42.0878L339.861 0.0963019L297.538 42.2804V101.937H237.684Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.678 234.713H324.785V278.462H368.678V234.713Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.678 129.095H324.785V172.843H368.678V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.781 172.844L293.745 203.779L324.781 234.713L355.818 203.779L324.781 172.844Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.644 234.713H430.751V278.462H474.644V234.713Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.644 129.095H430.751V172.843H474.644V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.641 172.847L443.604 203.781L474.641 234.716L505.677 203.781L474.641 172.847Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.711 98.1623L368.675 129.097L399.711 160.032L430.748 129.097L399.711 98.1623Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.71 247.528L368.673 278.463L399.71 309.397L430.747 278.463L399.71 247.528Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.038 101.937L399.715 59.7531L357.392 101.937H297.538V161.594L255.215 203.778L297.538 245.962V305.619H357.392L399.715 347.803L442.038 305.619H501.892V245.962L544.215 203.778L501.892 161.594V101.937H442.038Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.937 234.713H22.0441V278.462H65.937V234.713Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.937 129.095H22.0441V172.843H65.937V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9352 172.843L34.8986 203.778L65.9352 234.712L96.9719 203.778L65.9352 172.843Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.99348 98.1591L-40.0302 129.094L-8.99348 160.028L22.0432 129.094L-8.99348 98.1591Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.99458 247.525L-40.0312 278.459L-8.99458 309.394L22.0421 278.459L-8.99458 247.525Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.3157 101.937L-8.99292 59.7531L33.3303 101.937H93.1843V161.594L135.507 203.778L93.1843 245.962V305.619H33.3303L-8.99292 347.803L-51.3157 305.619H-111.17V245.962L-153.493 203.778L-111.17 161.594V101.937H-51.3157Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.684 221.251L255.215 203.778L237.684 186.305V161.594H212.892L195.361 144.121L177.83 161.594H153.038V186.305L135.507 203.778L153.038 221.251V245.962H177.83L195.361 263.435L212.892 245.962H237.684V221.251Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.291 129.095H237.684V161.594H270.291V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.432 161.595L153.038 161.595L153.038 129.095L120.432 129.095L120.432 161.595Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.291 245.962H237.684V278.462H270.291V245.962Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.432 278.462L153.038 278.462L153.038 245.962L120.432 245.962L120.432 278.462Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.038 17.5756L459.569 0.102053L442.038 -17.3711V-42.0816H417.246L399.715 -59.5547L382.184 -42.0816H357.392V-17.3711L339.861 0.102053L357.392 17.5756V42.2862H382.184L399.715 59.7593L417.246 42.2862H442.038V17.5756Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.644 42.2861H442.038V74.7856H474.644V42.2861Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.785 74.7857L357.392 74.7857L357.392 42.2863L324.785 42.2863L324.785 74.7857Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3229 17.5756L50.8541 0.102053L33.3229 -17.3711V-42.0816H8.53083L-8.99991 -59.5547L-26.5307 -42.0816H-51.3227V-17.3711L-68.8539 0.102053L-51.3227 17.5756V42.2862H-26.5307L-8.99991 59.7593L8.53083 42.2862H33.3229V17.5756Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9295 42.2861H33.3229V74.7856H65.9295V42.2861Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.324 740.141H120.431V783.889H164.324V740.141Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.425 783.884L89.3888 814.819L120.425 845.753L151.462 814.819L120.425 783.884Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.291 740.141H226.398V783.889H270.291V740.141Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.282 783.888L239.246 814.822L270.282 845.757L301.319 814.822L270.282 783.888Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.355 709.203L164.318 740.138L195.355 771.072L226.391 740.138L195.355 709.203Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.684 712.983L195.361 670.799L153.038 712.983H93.1843V772.64L50.8611 814.824L93.1843 857.008V916.665H153.038L195.361 958.849L237.684 916.665H297.538V857.008L339.861 814.824L297.538 772.64V712.983H237.684Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.678 536.459H324.785V580.208H368.678V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.678 642.077H324.785V685.826H368.678V642.077Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.778 580.207L293.741 611.141L324.778 642.076L355.815 611.141L324.778 580.207Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.644 536.459H430.751V580.208H474.644V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.644 642.077H430.751V685.826H474.644V642.077Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.637 580.205L443.601 611.139L474.637 642.074L505.674 611.139L474.637 580.205Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.707 654.889L368.671 685.823L399.707 716.758L430.744 685.823L399.707 654.889Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.709 505.523L368.672 536.458L399.709 567.392L430.745 536.458L399.709 505.523Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.038 712.983L399.715 755.168L357.392 712.983H297.538V653.327L255.215 611.143L297.538 568.958V509.302H357.392L399.715 467.117L442.038 509.302H501.892V568.958L544.215 611.143L501.892 653.327V712.983H442.038Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.937 536.459H22.0441V580.208H65.937V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.937 642.077H22.0441V685.826H65.937V642.077Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9328 580.203L34.8961 611.138L65.9328 642.073L96.9694 611.138L65.9328 580.203Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.99775 654.887L-40.0344 685.822L-8.99773 716.756L22.0389 685.822L-8.99775 654.887Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.99653 505.521L-40.0332 536.456L-8.99655 567.39L22.0401 536.456L-8.99653 505.521Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.3157 712.983L-8.99292 755.168L33.3303 712.983H93.1843V653.327L135.507 611.143L93.1843 568.958V509.302H33.3303L-8.99292 467.117L-51.3157 509.302H-111.17V568.958L-153.493 611.143L-111.17 653.327V712.983H-51.3157Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.684 593.669L255.215 611.143L237.684 628.616V653.326H212.892L195.361 670.799L177.83 653.326H153.038V628.616L135.507 611.143L153.038 593.669V568.958H177.83L195.361 551.485L212.892 568.958H237.684V593.669Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.291 653.326H237.684V685.826H270.291V653.326Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.432 685.826L153.038 685.826L153.038 653.326L120.432 653.326L120.432 685.826Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.291 536.459H237.684V568.958H270.291V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.432 568.958L153.038 568.958L153.038 536.459L120.432 536.459L120.432 568.958Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.038 797.345L459.569 814.819L442.038 832.292V857.002H417.246L399.715 874.475L382.184 857.002H357.392V832.292L339.861 814.819L357.392 797.345V772.634H382.184L399.715 755.161L417.246 772.634H442.038V797.345Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.644 740.135H442.038V772.634H474.644V740.135Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.785 772.634L357.392 772.634L357.392 740.135L324.785 740.135L324.785 772.634Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3229 797.345L50.8541 814.819L33.3229 832.292V857.002H8.53083L-8.99991 874.475L-26.5307 857.002H-51.3227V832.292L-68.8539 814.819L-51.3227 797.345V772.634H-26.5307L-8.99991 755.161L8.53083 772.634H33.3229V797.345Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9295 740.135H33.3229V772.634H65.9295V740.135Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.038 424.933L459.569 407.46L442.038 389.987V365.276H417.246L399.715 347.803L382.184 365.276H357.392V389.987L339.861 407.46L357.392 424.933V449.644H382.184L399.715 467.118L417.246 449.644H442.038V424.933Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.644 332.777H442.038V365.276H474.644V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.785 365.276L357.392 365.276L357.392 332.777L324.785 332.777L324.785 365.276Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.644 449.644H442.038V482.143H474.644V449.644Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.785 482.144L357.392 482.144L357.392 449.645L324.785 449.645L324.785 482.144Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3229 424.933L50.8541 407.46L33.3229 389.987V365.276H8.53083L-8.99991 347.803L-26.5307 365.276H-51.3227V389.987L-68.8539 407.46L-51.3227 424.933V449.644H-26.5307L-8.99991 467.118L8.53083 449.644H33.3229V424.933Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9295 332.777H33.3229V365.276H65.9295V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9295 449.644H33.3229V482.143H65.9295V449.644Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.998 438.395H635.106V482.144H678.998V438.395Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.998 332.777H635.106V376.525H678.998V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.991 376.528L647.954 407.463L678.991 438.398L710.028 407.463L678.991 376.528Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.032 438.395H529.139V482.144H573.032V438.395Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.032 332.777H529.139V376.525H573.032V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.132 376.525L498.096 407.459L529.132 438.394L560.169 407.459L529.132 376.525Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.062 301.843L573.026 332.778L604.062 363.713L635.099 332.778L604.062 301.843Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.061 451.209L573.025 482.144L604.061 513.078L635.098 482.144L604.061 451.209Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.745 305.619L604.069 263.435L646.392 305.619H706.245V365.276L748.569 407.46L706.245 449.644V509.301H646.392L604.069 551.485L561.745 509.301H501.892V449.644L459.569 407.46L501.892 365.276V305.619H561.745Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.998 31.0312H635.105V74.7798H678.998V31.0312Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.993 -30.834L647.956 0.100586L678.993 31.0352L710.03 0.100602L678.993 -30.834Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.032 31.0312H529.139V74.7798H573.032V31.0312Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.136 -30.8337L498.1 0.101013L529.136 31.0357L560.173 0.100994L529.136 -30.8337Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.064 43.8489L573.028 74.7836L604.064 105.718L635.101 74.7836L604.064 43.8489Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.745 101.937L604.069 144.121L646.392 101.937H706.245V42.2804L748.569 0.0963019L706.245 -42.0878V-101.745H646.392L604.069 -143.929L561.745 -101.745H501.892V-42.0878L459.569 0.0963019L501.892 42.2804V101.937H561.745Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.386 234.713H733.493V278.462H777.386V234.713Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.386 129.095H733.493V172.843H777.386V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.486 172.846L702.449 203.781L733.486 234.716L764.523 203.781L733.486 172.846Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.352 234.713H839.46V278.462H883.352V234.713Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.352 129.095H839.46V172.843H883.352V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.346 172.85L852.31 203.785L883.346 234.719L914.383 203.785L883.346 172.85Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.416 98.1654L777.38 129.1L808.416 160.035L839.453 129.1L808.416 98.1654Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.415 247.531L777.378 278.466L808.415 309.4L839.452 278.466L808.415 247.531Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.745 101.937L808.423 59.7531L766.099 101.937H706.245V161.594L663.923 203.778L706.245 245.962V305.619H766.099L808.423 347.803L850.745 305.619H910.599V245.962L952.923 203.778L910.599 161.594V101.937H850.745Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.746 221.251L544.215 203.778L561.746 186.305V161.594H586.538L604.069 144.121L621.599 161.594H646.392V186.305L663.922 203.778L646.392 221.251V245.962H621.599L604.069 263.435L586.538 245.962H561.746V221.251Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.139 161.595L561.746 161.595L561.746 129.095L529.139 129.095L529.139 161.595Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.998 129.095H646.392V161.594H678.998V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.139 278.462L561.746 278.462L561.746 245.962L529.139 245.962L529.139 278.462Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.998 245.962H646.392V278.462H678.998V245.962Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.107 17.5756L748.576 0.102053L766.107 -17.3711V-42.0816H790.899L808.43 -59.5547L825.96 -42.0816H850.753V-17.3711L868.283 0.102053L850.753 17.5756V42.2862H825.96L808.43 59.7593L790.899 42.2862H766.107V17.5756Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.5 74.7857L766.107 74.7857L766.107 42.2863L733.5 42.2863L733.5 74.7857Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.359 42.2861H850.753V74.7856H883.359V42.2861Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.998 740.141H635.105V783.889H678.998V740.141Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.988 783.89L647.951 814.825L678.988 845.759L710.024 814.825L678.988 783.89Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.032 740.141H529.139V783.889H573.032V740.141Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.13 783.885L498.093 814.82L529.13 845.755L560.167 814.82L529.13 783.885Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.06 709.205L573.023 740.139L604.06 771.074L635.096 740.139L604.06 709.205Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.745 712.983L604.069 670.799L646.392 712.983H706.245V772.64L748.569 814.824L706.245 857.008V916.665H646.392L604.069 958.849L561.745 916.665H501.892V857.008L459.569 814.824L501.892 772.64V712.983H561.745Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.386 536.459H733.493V580.208H777.386V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.386 642.077H733.493V685.826H777.386V642.077Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.484 580.21L702.447 611.144L733.484 642.079L764.52 611.144L733.484 580.21Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.352 536.459H839.459V580.208H883.352V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.352 642.077H839.459V685.826H883.352V642.077Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.341 580.207L852.305 611.142L883.341 642.076L914.378 611.142L883.341 580.207Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.412 654.891L777.375 685.826L808.412 716.761L839.449 685.826L808.412 654.891Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.413 505.526L777.376 536.46L808.413 567.395L839.45 536.46L808.413 505.526Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.745 712.983L808.423 755.168L766.099 712.983H706.245V653.327L663.923 611.143L706.245 568.958V509.302H766.099L808.423 467.117L850.745 509.302H910.599V568.958L952.923 611.143L910.599 653.327V712.983H850.745Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.746 593.669L544.215 611.143L561.746 628.616V653.326H586.538L604.069 670.799L621.599 653.326H646.392V628.616L663.922 611.143L646.392 593.669V568.958H621.599L604.069 551.485L586.538 568.958H561.746V593.669Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.139 685.826L561.746 685.826L561.746 653.326L529.139 653.326L529.139 685.826Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.998 653.326H646.392V685.826H678.998V653.326Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.139 568.958L561.746 568.958L561.746 536.459L529.139 536.459L529.139 568.958Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.998 536.459H646.392V568.958H678.998V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.07 234.713H1248.18V278.462H1292.07V234.713Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.07 129.095H1248.18V172.843H1292.07V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.07 172.852L1261.03 203.787L1292.07 234.722L1323.1 203.787L1292.07 172.852Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.11 234.713H1142.21V278.462H1186.11V234.713Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.11 129.095H1142.21V172.843H1186.11V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.2 172.848L1111.17 203.782L1142.2 234.717L1173.24 203.782L1142.2 172.848Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.13 98.1668L1186.1 129.101L1217.13 160.036L1248.17 129.101L1217.13 98.1668Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.13 247.532L1186.1 278.467L1217.13 309.402L1248.17 278.467L1217.13 247.532Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.82 101.937L1217.14 59.7531L1259.47 101.937H1319.32V161.594L1361.64 203.778L1319.32 245.962V305.619H1259.47L1217.14 347.803L1174.82 305.619H1114.97V245.962L1072.64 203.778L1114.97 161.594V101.937H1174.82Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.82 17.5756L1157.29 0.102053L1174.82 -17.3711V-42.0816H1199.61L1217.14 -59.5547L1234.68 -42.0816H1259.47V-17.3711L1277 0.102053L1259.47 17.5756V42.2862H1234.68L1217.14 59.7593L1199.61 42.2862H1174.82V17.5756Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.21 74.7857L1174.82 74.7857L1174.82 42.2863L1142.21 42.2863L1142.21 74.7857Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.07 42.2861H1259.47V74.7856H1292.07V42.2861Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.07 536.459H1248.18V580.208H1292.07V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.07 642.077H1248.18V685.826H1292.07V642.077Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.06 580.211L1261.02 611.145L1292.06 642.08L1323.1 611.145L1292.06 580.211Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.11 536.459H1142.21V580.208H1186.11V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.11 642.077H1142.21V685.826H1186.11V642.077Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.2 580.215L1111.17 611.149L1142.2 642.084L1173.24 611.149L1142.2 580.215Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.13 654.896L1186.09 685.831L1217.13 716.765L1248.17 685.831L1217.13 654.896Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.13 505.53L1186.1 536.465L1217.13 567.4L1248.17 536.465L1217.13 505.53Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.82 712.983L1217.14 755.168L1259.47 712.983H1319.32V653.327L1361.64 611.143L1319.32 568.958V509.302H1259.47L1217.14 467.117L1174.82 509.302H1114.97V568.958L1072.64 611.143L1114.97 653.327V712.983H1174.82Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.82 797.345L1157.29 814.819L1174.82 832.292V857.002H1199.61L1217.14 874.475L1234.68 857.002H1259.47V832.292L1277 814.819L1259.47 797.345V772.634H1234.68L1217.14 755.161L1199.61 772.634H1174.82V797.345Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.21 772.634L1174.82 772.634L1174.82 740.135L1142.21 740.135L1142.21 772.634Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.07 740.135H1259.47V772.634H1292.07V740.135Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.82 424.933L1157.29 407.46L1174.82 389.987V365.276H1199.61L1217.14 347.803L1234.68 365.276H1259.47V389.987L1277 407.46L1259.47 424.933V449.644H1234.68L1217.14 467.118L1199.61 449.644H1174.82V424.933Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.21 365.276L1174.82 365.276L1174.82 332.777L1142.21 332.777L1142.21 365.276Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.07 332.777H1259.47V365.276H1292.07V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.21 482.144L1174.82 482.144L1174.82 449.645L1142.21 449.645L1142.21 482.144Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.07 449.644H1259.47V482.143H1292.07V449.644Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.754 438.395H937.861V482.144H981.754V438.395Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.754 332.777H937.861V376.525H981.754V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.851 376.528L906.815 407.462L937.851 438.397L968.888 407.462L937.851 376.528Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.72 438.395H1043.83V482.144H1087.72V438.395Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.72 332.777H1043.83V376.525H1087.72V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.71 376.533L1056.67 407.467L1087.71 438.402L1118.75 407.467L1087.71 376.533Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.78 301.848L981.745 332.782L1012.78 363.717L1043.82 332.782L1012.78 301.848Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.78 451.213L981.744 482.148L1012.78 513.083L1043.82 482.148L1012.78 451.213Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.11 305.619L1012.79 263.435L970.467 305.619H910.614V365.276L868.291 407.46L910.614 449.644V509.301H970.467L1012.79 551.485L1055.11 509.301H1114.97V449.644L1157.29 407.46L1114.97 365.276V305.619H1055.11Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.754 31.0312H937.861V74.7799H981.754V31.0312Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.855 -30.831L906.819 0.103638L937.855 31.0383L968.892 0.103654L937.855 -30.831Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.72 31.0312H1043.83V74.7799H1087.72V31.0312Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.71 -30.8326L1056.67 0.102051L1087.71 31.0367L1118.75 0.102067L1087.71 -30.8326Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.78 43.8506L981.746 74.7853L1012.78 105.72L1043.82 74.7853L1012.78 43.8506Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.11 101.937L1012.79 144.121L970.467 101.937H910.614V42.2804L868.291 0.0963019L910.614 -42.0878V-101.745H970.467L1012.79 -143.929L1055.11 -101.745H1114.97V-42.0878L1157.29 0.0963019L1114.97 42.2804V101.937H1055.11Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.11 221.251L1072.64 203.778L1055.11 186.305V161.594H1030.32L1012.79 144.121L995.26 161.594H970.468V186.305L952.937 203.778L970.468 221.251V245.962H995.26L1012.79 263.435L1030.32 245.962H1055.11V221.251Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.72 129.095H1055.11V161.594H1087.72V129.095Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.861 161.595L970.468 161.595L970.468 129.095L937.861 129.095L937.861 161.595Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.72 245.962H1055.11V278.462H1087.72V245.962Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.861 278.462L970.467 278.462L970.467 245.962L937.861 245.962L937.861 278.462Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.754 740.141H937.861V783.889H981.754V740.141Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.849 783.889L906.812 814.823L937.849 845.758L968.885 814.823L937.849 783.889Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.72 740.141H1043.83V783.889H1087.72V740.141Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.71 783.895L1056.67 814.829L1087.71 845.764L1118.74 814.829L1087.71 783.895Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.78 709.209L981.742 740.144L1012.78 771.078L1043.82 740.144L1012.78 709.209Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.11 712.983L1012.79 670.799L970.467 712.983H910.614V772.64L868.291 814.824L910.614 857.008V916.665H970.467L1012.79 958.849L1055.11 916.665H1114.97V857.008L1157.29 814.824L1114.97 772.64V712.983H1055.11Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.11 593.669L1072.64 611.143L1055.11 628.616V653.326H1030.32L1012.79 670.799L995.26 653.326H970.468V628.616L952.937 611.143L970.468 593.669V568.958H995.26L1012.79 551.485L1030.32 568.958H1055.11V593.669Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.72 653.326H1055.11V685.826H1087.72V653.326Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.861 685.826L970.467 685.826L970.467 653.326L937.861 653.326L937.861 685.826Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.72 536.459H1055.11V568.958H1087.72V536.459Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.861 568.958L970.468 568.958L970.468 536.459L937.861 536.459L937.861 568.958Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.46 438.395H1346.57V482.144H1390.46V438.395Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.46 332.777H1346.57V376.525H1390.46V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.55 376.529L1315.52 407.463L1346.55 438.398L1377.59 407.463L1346.55 376.529Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.49 301.848L1390.45 332.783L1421.49 363.718L1452.52 332.783L1421.49 301.848Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.48 451.214L1390.45 482.149L1421.48 513.083L1452.52 482.149L1421.48 451.214Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.18 305.619L1421.5 263.435L1463.82 305.619H1523.68V365.276L1566 407.46L1523.68 449.644V509.301H1463.82L1421.5 551.485L1379.18 509.301H1319.32V449.644L1277 407.46L1319.32 365.276V305.619H1379.18Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.46 31.0312H1346.57V74.7799H1390.46V31.0312Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.56 -30.8267L1315.53 0.107971L1346.56 31.0426L1377.6 0.107987L1346.56 -30.8267Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.49 43.855L1390.45 74.7896L1421.49 105.724L1452.53 74.7897L1421.49 43.855Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.18 101.937L1421.5 144.121L1463.82 101.937H1523.68V42.2804L1566 0.0963019L1523.68 -42.0878V-101.745H1463.82L1421.5 -143.929L1379.18 -101.745H1319.32V-42.0878L1277 0.0963019L1319.32 42.2804V101.937H1379.18Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.18 221.251L1361.64 203.778L1379.18 186.305V161.594H1403.97L1421.5 144.121L1439.03 161.594H1463.82V186.305L1481.35 203.778L1463.82 221.251V245.962H1439.03L1421.5 263.435L1403.97 245.962H1379.18V221.251Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.57 161.595L1379.17 161.595L1379.17 129.095L1346.57 129.095L1346.57 161.595Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.57 278.462L1379.17 278.462L1379.17 245.962L1346.57 245.962L1346.57 278.462Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.46 740.141H1346.57V783.889H1390.46V740.141Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.55 783.889L1315.52 814.824L1346.55 845.759L1377.59 814.824L1346.55 783.889Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.48 709.21L1390.45 740.144L1421.48 771.079L1452.52 740.144L1421.48 709.21Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.18 712.983L1421.5 670.799L1463.82 712.983H1523.68V772.64L1566 814.824L1523.68 857.008V916.665H1463.82L1421.5 958.849L1379.18 916.665H1319.32V857.008L1277 814.824L1319.32 772.64V712.983H1379.18Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.18 593.669L1361.64 611.143L1379.18 628.616V653.326H1403.97L1421.5 670.799L1439.03 653.326H1463.82V628.616L1481.35 611.143L1463.82 593.669V568.958H1439.03L1421.5 551.485L1403.97 568.958H1379.18V593.669Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.57 685.826L1379.17 685.826L1379.17 653.326L1346.57 653.326L1346.57 685.826Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.57 568.958L1379.17 568.958L1379.17 536.459L1346.57 536.459L1346.57 568.958Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.107 797.345L748.576 814.819L766.107 832.292V857.002H790.899L808.43 874.475L825.96 857.002H850.753V832.292L868.283 814.819L850.753 797.345V772.634H825.96L808.43 755.161L790.899 772.634H766.107V797.345Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.5 772.634L766.107 772.634L766.107 740.135L733.5 740.135L733.5 772.634Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.359 740.135H850.753V772.634H883.359V740.135Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.107 424.933L748.576 407.46L766.107 389.987V365.276H790.899L808.43 347.803L825.96 365.276H850.753V389.987L868.283 407.46L850.753 424.933V449.644H825.96L808.43 467.118L790.899 449.644H766.107V424.933Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.5 365.276L766.107 365.276L766.107 332.777L733.5 332.777L733.5 365.276Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.359 332.777H850.753V365.276H883.359V332.777Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.5 482.144L766.107 482.144L766.107 449.645L733.5 449.645L733.5 482.144Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.359 449.644H850.753V482.143H883.359V449.644Z",
    stroke: "#F98007",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1445,
    height: 823,
    fill: "white",
    transform: "translate(-9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgPattern);
export default __webpack_public_path__ + "static/media/heroBgPattern.59f0e25176f987dd3bef3ff846bbd51d.svg";
export { ForwardRef as ReactComponent };